import { calculateDistance as calculateDistanceFromUtils } from '@ocx/utils';

import { Coordinates } from '../../../modules/stores/types';

export const calculateDistance = (from: Coordinates, to: Coordinates, units: 'km' | 'mi' = 'mi'): number => {
  return calculateDistanceFromUtils(from, to, units);
};
